import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { fetchGymFeedbacksData } from "../../redux/hygiene-reducers/hygieneSlice";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import GymFeedbackListings from "../../components/gym-feedback/GymFeedbackListings";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import GymIssueResolveForm from "./GymIssueResolveForm";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";

const GymFeedback = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();

  const { gymFeedbacksLoading } = useSelector((state) => state.hygiene);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedApprovalStatus: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    resolve_status: allFilters.selectedApprovalStatus?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getFeedbacks(filters) {
    dispatch(
      fetchGymFeedbacksData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getFeedbacks(filters);
  }, [filters]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      resolve_status: allFilters.selectedApprovalStatus?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedApprovalStatus,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Feedbacks">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}>
          <div className={`createNewCTOModalContainer mod-width-50p`}>
            <ModalHeadAndClose
              title={
                modValues.cardName === "resolve-form"
                  ? modValues.rowData?.gym_name || "Resolve Issue"
                  : `${modValues.cardName?.replace(/_/g, " ")}`
              }
              onClose={onCloseModal}
            />

            {modValues.cardName === "feedback" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.feedback || "No Content Available"}
                </p>
              </div>
            ) : modValues.cardName === "resolve-form" ? (
              <GymIssueResolveForm
                callFunction={() => {
                  getFeedbacks(filters);
                  onCloseModal();
                }}
                userInfoData={userInfoData}
                rowData={modValues.rowData}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"All Feedbacks"}
              isReload={() => getFeedbacks(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"gym-feedbacks"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={gymFeedbacksLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <GymFeedbackListings
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default GymFeedback;
